import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { BreakpointObserver } from '@angular/cdk/layout';
import { SassHelperComponent } from '../../../providers/sass-helper/sass-helper.component';
import { ResponsiveMode } from '../../../models/responsive-mode.type';

@Component({
  selector: 'morva-error404',
  templateUrl: './error404.component.html',
  styleUrls: ['./../error.scss'],
})
export class Error404Component implements OnInit {

  responsiveMode: ResponsiveMode;
  private sassHelper: SassHelperComponent;
  constructor(private location: Location,
    private breakPointObserver: BreakpointObserver) {
    this.sassHelper = new SassHelperComponent();
  }

  ngOnInit(): void {
    this.breakPointObserver.observe([this.sassHelper.mdMaxWidth]).subscribe(state => {
      if (state.breakpoints[this.sassHelper.mdMaxWidth]) {
        this.responsiveMode = 'md';
      } else {
        this.responsiveMode = 'lg';
      }
    });
  }

  pageBack() {
    this.location.back();
  }
}
